import { AssetIntegrationProviders } from '@/modules/assetProviderIntegrations/shared/constants';
import { EntityKind } from '@/types/schema';

export const businessEntityKinds = new Set([
  EntityKind.LlcBusinessEntity,
  EntityKind.LpBusinessEntity,
  EntityKind.GpBusinessEntity,
  EntityKind.SoleProprietorshipBusinessEntity,
  EntityKind.ScorpBusinessEntity,
  EntityKind.CcorpBusinessEntity,
]);

// We only support syncing ownership for these integrations
export const OWNERSHIP_SYNC_SUPPORTED_INTEGRATIONS = new Set([
  AssetIntegrationProviders.ADDEPAR,
  AssetIntegrationProviders.EMONEY,
]);
